import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import EmptyTableIcon from 'shared/img/empty-table.webp'
import { ReactComponent as SearchSVG } from 'shared/img/slots/search.svg'

import { selectLocaleDict } from 'features/locale/selectors'

import './EmptySearchResult.scss'

const b = block('empty-search')

export const EmptySearchResult: React.FC = () => {
  const locale = useSelector(selectLocaleDict, shallowEqual).common

  return (
    <div className={b()}>
      <img src={EmptyTableIcon} alt="icon" className={b('icon')} />
      <h3 className={b('title')}>{locale.table.empty.title}</h3>
    </div>
  )
}
